module.exports = __webpack_public_path__ + "img/qrcode-bg.6d7b399b.png";